module.exports = __webpack_public_path__ + "img/HZ-P6005.040e9134.jpg";